import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@99designs/common/components/Alert';
import { Icon } from '@99designs/common/components/Icon';

export default class IneligibleContest extends React.Component {
    render() {
        return (
            <Alert
                variations={[this.props.className]}
                icon={<Icon variations={[this.props.iconName]} />}
            >
                {this.props.message}
                &nbsp;
                <a href={this.props.linkUrl} className="link link--default link--bleached-as">
                    {this.props.linkMessage}
                </a>
            </Alert>
        );
    }
}

IneligibleContest.propTypes = {
    className: PropTypes.string.isRequired,
    iconName: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    linkMessage: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/IneligibleContestAlert.jsx